<template>
  <div>
    <p>Cette section est réservée aux organisateurs. Veuillez utiliser les identifiants fournis par Sportips afin de
      vous connecter, vos identifiants personnels ne fonctionneront pas.</p>

    <v-form ref="login_form">
      <label class="field_label">Identifiant</label>
      <v-text-field class="my-1" v-model="admin.username" :rules="[$formRules.required]"></v-text-field>
      <label class="field_label">Mot de passe</label>
      <v-text-field v-model="admin.pass" :rules="[$formRules.required]" :type="showpass ? 'text' : 'password'"
        :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showpass = !showpass"></v-text-field>

      <v-alert color="dark-red" variant="tonal" density="compact" class="mb-2" v-if="error" type="error">{{ error
        }}</v-alert>
      <v-btn color="primary-dark" variant="tonal" size="large" class="mb-3" block @click="handleLogin">Se
        connecter</v-btn>
    </v-form>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';
export default {
  data() {
    return {
      showpass: false,
      error: "",
      admin: {
        username: "",
        pass: "",
      },
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },

  methods: {
    async handleLogin() {
      const { valid } = await this.$refs.login_form.validate();
      if (valid) {
        await this.mainStore.authAdmin.login(this.admin);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>